import React from "react";
import styled from "styled-components/macro";
import { useNavigate } from "react-router-dom";
import { Avatar, Grid, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Label, TextField } from "../../../components";

const ImageAvatar = styled(Avatar)`
  height: 130px;
  width: 130px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
`;

export default function FormOne({ formData }) {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      {/* <Paper gridSpacing={6}> */}
      <Grid item xs={6} textAlign="center" display="flex">
        <ImageAvatar src={formData.brandAvatar} />
      </Grid>

      <Grid item xs={6} display={"flex"} justifyContent={"end"}>
        {formData.agency?.agency_name && (
          <Tooltip title="View Agency Details">
            <div
              className="agency-name-brand"
              onClick={() =>
                navigate(
                  pages.unverifiedAgenciesDetails.route +
                    "?agencyID=" +
                    formData.agency?.agency_id
                )
              }
            >
              Agency - {formData.agency?.agency_name}
            </div>
          </Tooltip>
        )}
      </Grid>

      <Grid item xs={6}>
        <Label title="Brand Name" />

        <TextField
          disabled
          value={formData.brandName}
          placeholder="Brand Name"
          name="brandName"
          size="small"
        />

        <Label title="Online Store" />

        <TextField
          size="small"
          value={formData.onlineStore}
          disabled
          name="onlineStore"
          placeholder="Online Store"
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="About" />

        <TextField
          size="small"
          value={formData.about}
          disabled
          placeholder="About"
          name="about"
          rows={5}
          multiline
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Website" />

        <TextField
          size="small"
          value={formData.website}
          disabled
          name="website"
          placeholder="Website"
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Monthly Active Users" />

        <TextField
          size="small"
          disabled
          value={formData.monthlyActiveUsers}
          name="monthlyActiveUsers"
          placeholder="Monthly Active Users"
        />
      </Grid>
    </React.Fragment>
  );
}
